exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper{margin-top:50px}@media screen and (max-width:560px){.wrapper{margin-top:100px}}.sidebar-toggle{margin-left:10px}.bell_bg button.btn-secondary{background-color:#080a0a;border:none;border-radius:0;-webkit-box-shadow:none!important;box-shadow:none!important;padding:0}.bell_bg button.btn-secondary:hover{background-color:#ededed!important}.bell_bg button.btn-secondary:active{color:#fff!important}.bell_bg.show button{background-color:#ededed!important}.bell_bg.user_btn .dropdown-toggle{padding:7px 9px}.event_date,.tabs_cont{background-color:#fff!important}body.left-hidden aside.right-aside{margin-left:0}body.left-hidden .header.fixed-top{padding-right:0!important;min-width:250px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26edd230","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/layouts/header/fixed-header.vue
// module id = ILSG
// module chunks = 1